import React from "react";
import { BusinessCreditReportStatePII } from "../../../store/businessCreditReportService/types";

interface IProps {
    reportObject: BusinessCreditReportStatePII;
    isBankrupt: boolean;
}

const BCreditScoreTracker: React.FunctionComponent<IProps> = (props) => {
    return (
        <div className={props.isBankrupt ? "legend bankrupt" : "legend"}>
            {props.isBankrupt && (
                <span className="key lvl-not-rated-risk-bg">
                    <span>X</span>
                </span>
            )}
            <span className={props.isBankrupt ? "key lvl-very-high-risk-bg bankrupt" : "key lvl-very-high-risk-bg"}>
                <span>5</span>
            </span>
            <span className={props.isBankrupt ? "key lvl-high-risk-bg bankrupt" : "key lvl-high-risk-bg"}>
                <span>4</span>
            </span>
            <span className={props.isBankrupt ? "key lvl-moderate-risk-bg bankrupt" : "key lvl-moderate-risk-bg"}>
                <span>3</span>
            </span>
            <span className={props.isBankrupt ? "key lvl-low-risk-bg bankrupt" : "key lvl-low-risk-bg"}>
                <span>2</span>
            </span>
            <span className={props.isBankrupt ? "key lvl-very-low-risk-bg bankrupt" : "key lvl-very-low-risk-bg"}>
                <span>1</span>
            </span>
        </div>
    );
};

export default BCreditScoreTracker;
